import CenteredHeader from "./../../Molecules/CenteredHeader/CenteredHeader";
import IndustryImageTextSection from "./../../Molecules/IndustryImageTextSection/IndustryImageTextSection";
import AUTOMOVILES_IMG from "../../../assets/img/AUTOMOVILES_IMG.jpg";
import IndustryBannerBgSection from "../../Atoms/IndustryBannerBgSection/IndustryBannerBgSection";
import IndustryLightBlueSection from "./../../Organisms/IndustryLightBlueSection/IndustryLightBlueSection";
import content from "./content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";

const FamilyAutomoviles = () => {
	const {language} = useLanguageCtx();
	const { dropdownHeader } = useScrollCtx();

	return (
		<>
			<ChangeableHeaderV2
				appearSecondNavbar={dropdownHeader} 
				withTitle 
				titleBanner={content[language].header_title} 
			/>

			<div className="top-space-section">
				<CenteredHeader
					yellowText={content[language].automoviles_yellow_title}
					boldText={content[language].automoviles_bold_title}
				/>
			</div>

			<div className="top-space-section">
				<IndustryImageTextSection
					image={{ img: AUTOMOVILES_IMG, alt: "Tablet con Mapa en Pantalla" }}
					yellowText={content[language].beneficios_yellow_title}
					checkText={content[language].beneficios_list}
				/>
			</div>

			<div className="top-space-section">
				<div className="light-blue-bg top-space-section bottom-space-section padding">
					<CenteredHeader
						yellowText={content[language].ubicacion_yellow_title}
						boldText={content[language].ubicacion_bold_title}
					/>
				</div>
			</div>

			<IndustryBannerBgSection route="my-tracker">
				<IndustryImageTextSection
					familyCase
					leftBoldText={content[language].beneficio_1_bold_text}
					lefText={content[language].beneficio_1_text}
					rightBoldText={content[language].beneficio_2_bold_text}
					rightext={content[language].beneficio_2_text}
				/>
			</IndustryBannerBgSection>

			<IndustryLightBlueSection
				whiteBg
				yellowText={content[language].caracteristicas_yellow_title}
				boldText={content[language].caracteristicas_bold_title}
				checkText={content[language].caracteristicas_list}
			/>
		</>
	);
};

export default FamilyAutomoviles;
